'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function SEFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-l4ydizz0a", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-izdf95vl6", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-oh0yuo0f4" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-oh0yuo0f4", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-l4ydizz0a)" }, /* @__PURE__ */ React.createElement("use", { fill: "#3d58db", xlinkHref: "#mantine-oh0yuo0f4" }), /* @__PURE__ */ React.createElement("g", { fill: "#feca00", mask: "url(#mantine-izdf95vl6)" }, /* @__PURE__ */ React.createElement("path", { d: "M10 0h4v10h18v4H14v10h-4V14H0v-4h10z" }))))
  );
}

export { SEFlag };
//# sourceMappingURL=SE.mjs.map
